// @ts-nocheck

import { defineMessages } from 'react-intl';

export default defineMessages({
  SEARCH_HELP_DOCUMENTATION: 'Help & support center',
  REPORT_ISSUE: 'Report an issue',
  CHAT_SUPPORT: 'Chat with support',
  PRIVACY_POLICY: 'Privacy policy',
  HELP: 'Help',
});
